import React from "react";
import { Checkbox } from "./Elements";

export default function InstallmentCheckBoxes({ ...props }) {
  return (
    <div className={`${props.className}`}>
      <Checkbox
        key={1}
        label={"Peşin"}
        name={`installment${1}`}
        type="checkbox"
        disabled={true}
        checked
      />
      {props.installments.map((installment) => {
        if (installment.month !== 1) {
          return (
            <Checkbox
              key={installment.month +""}
              id={installment.month +""}
              label={installment.month + " Taksit"}
              name={`installment${installment.month}`}
              type="checkbox"
              onChange={() => {
                props.callback(installment.month);
              }}
            />
          );
        } else {
          return null;
        }
      })}
    </div>
  );
}
